module.exports = __webpack_public_path__ + "static/img_pstake-af52c0e0c910b5a70a9ef8ed29b03406.png";